import {
  ApolloQueryResult,
  FetchMoreQueryOptions,
  QueryResult,
} from '@apollo/client';

import { ContentCard, Empty } from 'apps/dashboard/shared/scripts/components';
import { PaginationInput } from 'apps/shared/scripts/__generated__/graphql.generated';
import {
  InfiniteLoader,
  Table,
  TableBody,
  TableHead,
} from 'apps/shared/scripts/components';
import { SimpleInvoiceFragment } from 'apps/shared/scripts/graphql/fragments/InvoiceFragment.generated';

import InvoiceItem from './InvoiceItem';

interface Props {
  cursor: string;
  fetchMore: (
    options: FetchMoreQueryOptions<PaginationInput>,
  ) => Promise<ApolloQueryResult<QueryResult<SimpleInvoiceFragment>>>;
  hasNextPage: boolean;
  invoices: SimpleInvoiceFragment[];
}

const InvoicesTable = ({ cursor, fetchMore, hasNextPage, invoices }: Props) => {
  const list = invoices.map((invoice) => (
    <InvoiceItem key={invoice.id} {...invoice} />
  ));

  if (!list.length) {
    return <Empty description="No Invoices Found" />;
  }

  return (
    <ContentCard noPadding noBorder>
      <Table>
        <TableHead>
          <th scope="col">Invoice</th>
          <th scope="col">Card For</th>
          <th scope="col">Billing Date</th>
          <th scope="col">Amount</th>
          <th scope="col">Status</th>
        </TableHead>
        <TableBody>{list}</TableBody>
      </Table>
      <InfiniteLoader
        cursor={cursor}
        fetchMore={fetchMore}
        hasNextPage={hasNextPage}
      />
    </ContentCard>
  );
};

InvoicesTable.displayName = 'InvoicesTable';

export default InvoicesTable;
